// BNB Address
const BNB_ADDRESS = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c'
const TBNB_ADDRESS = '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd'
const ETH_ADDRESS = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'
const GOR_ADDRESS = '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6'

export { BNB_ADDRESS, TBNB_ADDRESS, ETH_ADDRESS, GOR_ADDRESS }
